import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/crm/accounts')({
  component: AccountsLayout,
})

function AccountsLayout() {
  return <Outlet />
}
